import {FC, useState, useCallback} from "react";
import {Box, TextField} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import SendIcon from "@mui/icons-material/Send";

const useStyles = makeStyles()((theme) => ({
	input: {
		width: "100%"
	},
	icon: {
		cursor: "pointer"
	},
	sendButtonInputAdornment: {
		marginTop: theme.spacing(0.75),
		height: "100%",
		alignSelf: "end"
	}
}));

interface NoteEditInputProps {
	initialValue: string;
	onPostNote: (note: string) => void;
	placeholder?: string;
	className?: string;
	disabled?: boolean;
}

/** Mirrors shapeshift notesLibrary/noteInput - for editing (initialValue, onPostNote) */
export const NoteEditInput: FC<NoteEditInputProps> = ({
	onPostNote,
	placeholder = "Type your private note",
	className,
	initialValue = "",
	disabled = false
}) => {
	const {classes, cx} = useStyles();
	const [note, setNote] = useState(initialValue);

	const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setNote(event.target.value);
	}, []);

	const handleSubmit = useCallback(() => {
		if (!note.trim()) return;
		onPostNote(note.trim());
		setNote("");
	}, [note, onPostNote]);

	return (
		<TextField
			className={cx(classes.input, className)}
			placeholder={placeholder}
			data-test-id="note-edit-input"
			multiline
			value={note}
			onChange={handleChange}
			disabled={disabled}
			InputProps={{
				disableUnderline: true,
				autoCapitalize: "none",
				autoComplete: "off",
				endAdornment: (
					<Box
						className={classes.sendButtonInputAdornment}
						role="button"
						tabIndex={0}
						onClick={handleSubmit}
						sx={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "wait" : "pointer" }}
					>
						<SendIcon className={classes.icon} data-test-id="note-edit-submit-btn" />
					</Box>
				)
			}}
		/>
	);
};
